import PageLayout from "../components/PageLayout";
import Home from "../pages/Home/Index";
import ErrorPage from "../components/ErrorPage";
import EmptyPage from "../components/EmptyPage";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiePolicy from "../pages/CookiePolicy";

// Product Components
import EcommerceApp from "../pages/Products/EcommerceApp";
import SportReserve from "../pages/Products/SportReserve";
import TalentFlow from "../pages/TalentManagement/TalentFlow";
import QueueBridge from "../pages/Products/QueueBridge";

// Service Components
import AIAgenticSolutions from "../pages/Services/AIAgenticSolutions";
import ITConsultingStrategy from "../pages/Services/ITConsultingStrategy";
import CustomAppDevelopment from "../pages/Services/CustomAppDevelopment";
import QualityEngineeringAssurance from "../pages/Services/QualityEngineeringAssurance";
import MobileAppDevelopment from "../pages/Services/MobileAppDevelopment";
import ManagedITServices from "../pages/Services/ManagedITServices";

// Index Components
import ProductsIndex from "../pages/Products/Index";
import ServicesIndex from "../pages/Services/Index";
import IndustriesIndex from "../pages/Industries/Index";
import TalentManagementPage from "../pages/TalentManagement/Index";
import AboutPage from "../pages/About/Index";
import CareersPage from "../pages/Careers/Index";
import ContactPage from "../pages/Contact/Index";

// Industry Components
import Retail from "../pages/Industries/Retail";
import Healthcare from "../pages/Industries/Healthcare";
import InformationServices from "../pages/Industries/InformationServices";
import EducationSector from "../pages/Industries/Education";
import IndustriesTelecom from "../pages/Industries/Telecom";
import Finance from "../pages/Industries/Finance";

const routes = {
  home: "/",
  talentManagement: "/talentmanagement",
  about: "/about",
  careers: "/careers",
  contact: "/contact",
  privacyPolicy: "/privacy-policy",
  cookiePolicy: "/cookie-policy",
  products: {
    index: "/products",
    ecommerce: "/products/ecommerce-app",
    fastats: "/products/sport-reserve",
    customcrm: "/products/talent-flow",
    digitaltool: "/products/queue-bridge",
  },
  talentFlow: "/talentmanagement/talent-flow",
  industries: {
    index: "/industries",
    retail: "/industries/retail",
    healthcare: "/industries/healthcare",
    informationservices: "/industries/information-services",
    education: "/industries/education",
    insurance: "/industries/insurance",
    telecom: "/industries/telecom",
    finance: "/industries/finance",
  },
  services: {
    index: "/services",
    aiagenticsolutions: "/services/ai-agentic-solutions",
    itconsulting: "/services/it-consulting-strategy",
    customappdev: "/services/custom-app-development",
    qualityassurance: "/services/quality-engineering-assurance",
    mobileappdev: "/services/mobile-app-development",
    managedITservices: "/services/managed-it-services",
  },
};

const navMenus = [
  {
    route: routes.home,
    name: "Home",
  },
  {
    name: "Products",
    route: routes.products.index,
    children: [
      { route: routes.products.ecommerce, name: "Ecommerce App" },
      { route: routes.products.fastats, name: "Sport Reserve" },
      { route: routes.products.customcrm, name: "Talent Flow" },
      { route: routes.products.digitaltool, name: "Queue Bridge" },
    ],
  },

  {
    name: "Services",
    route: routes.services.index,
    children: [
      {
        route: routes.services.aiagenticsolutions,
        name: "AI and Agentic AI Solutions",
      },
      { route: routes.services.itconsulting, name: "IT Consulting & Strategy" },
      {
        route: routes.services.customappdev,
        name: "Custom Application Development",
      },
      {
        route: routes.services.qualityassurance,
        name: "Quality Engineering & Assurance",
      },
      {
        route: routes.services.mobileappdev,
        name: "Mobile Application Development",
      },
      {
        route: routes.services.managedITservices,
        name: "Managed IT services",
      },
    ],
  },
  {
    name: "Industries",
    route: routes.industries.index,
    // children: [
    //   { route: routes.industries.retail, name: "Retail" },
    //   { route: routes.industries.healthcare, name: "Healthcare" },
    //   { route: routes.industries.insurance, name: "Insurance" },
    //   { route: routes.industries.telecom, name: "Telecom" },
    //   { route: routes.industries.finance, name: "Finance" },
    // ],
  },
  {
    route: routes.talentManagement,
    name: "Talent Management",
  },
  {
    route: routes.about,
    name: "About",
  },
  {
    route: routes.careers,
    name: "Careers",
  },
  {
    route: routes.contact,
    name: "Contact",
  },
];

const routerData = [
  {
    path: routes.home,
    index: true,
    element: (
      <PageLayout>
        <Home />
      </PageLayout>
    ),
    errorElement: <ErrorPage />,
  },
  {
    path: routes.products.index,
    element: (
      <PageLayout>
        <ProductsIndex />
      </PageLayout>
    ),
  },
  {
    path: routes.products.index,
    children: [
      {
        path: routes.products.ecommerce,
        element: (
          <PageLayout>
            <EcommerceApp />
          </PageLayout>
        ),
      },
      {
        path: routes.products.fastats,
        element: (
          <PageLayout>
            <SportReserve />
          </PageLayout>
        ),
      },
      {
        path: routes.products.customcrm,
        element: (
          <PageLayout>
            <TalentFlow />
          </PageLayout>
        ),
      },
      {
        path: routes.products.digitaltool,
        element: (
          <PageLayout>
            <QueueBridge />
          </PageLayout>
        ),
      },
    ],
  },
  {
    path: routes.industries.index,
    element: (
      <PageLayout>
        <IndustriesIndex />
      </PageLayout>
    ),
  },
  {
    path: "/industries",
    children: [
      {
        path: routes.industries.healthcare,
        element: (
          <PageLayout>
            <Healthcare />
          </PageLayout>
        ),
      },
      {
        path: routes.industries.insurance,
        element: (
          <PageLayout>
            <EmptyPage title="Insurance" />
          </PageLayout>
        ),
      },
      {
        path: routes.industries.informationservices,
        element: (
          <PageLayout>
            <InformationServices />
          </PageLayout>
        ),
      },
      {
        path: routes.industries.education,
        element: (
          <PageLayout>
            <EducationSector />
          </PageLayout>
        ),
      },
      {
        path: routes.industries.finance,
        element: (
          <PageLayout>
            <Finance />
          </PageLayout>
        ),
      },
      {
        path: routes.industries.retail,
        element: (
          <PageLayout>
            <Retail />
          </PageLayout>
        ),
      },
      {
        path: routes.industries.telecom,
        element: (
          <PageLayout>
            <IndustriesTelecom />
          </PageLayout>
        ),
      },
    ],
  },
  {
    path: routes.services.index,
    element: (
      <PageLayout>
        <ServicesIndex />
      </PageLayout>
    ),
  },
  {
    path: "/services",
    children: [
      {
        path: routes.services.aiagenticsolutions,
        element: (
          <PageLayout>
            <AIAgenticSolutions />
          </PageLayout>
        ),
      },
      {
        path: routes.services.itconsulting,
        element: (
          <PageLayout>
            <ITConsultingStrategy />
          </PageLayout>
        ),
      },
      {
        path: routes.services.customappdev,
        element: (
          <PageLayout>
            <CustomAppDevelopment />
          </PageLayout>
        ),
      },
      {
        path: routes.services.qualityassurance,
        element: (
          <PageLayout>
            <QualityEngineeringAssurance />
          </PageLayout>
        ),
      },
      {
        path: routes.services.mobileappdev,
        element: (
          <PageLayout>
            <MobileAppDevelopment />
          </PageLayout>
        ),
      },
      {
        path: routes.services.managedITservices,
        element: (
          <PageLayout>
            <ManagedITServices />
          </PageLayout>
        ),
      },
    ],
  },
  {
    path: "/talentmanagement",
    element: (
      <PageLayout>
        <TalentManagementPage />
      </PageLayout>
    ),
  },
  {
    path: "/about",
    element: (
      <PageLayout>
        <AboutPage />
      </PageLayout>
    ),
  },
  {
    path: "/careers",
    element: (
      <PageLayout>
        <CareersPage />
      </PageLayout>
    ),
  },
  {
    path: "/contact",
    element: (
      <PageLayout>
        <ContactPage />
      </PageLayout>
    ),
  },
  {
    path: routes.privacyPolicy,
    element: (
      <PageLayout>
        <PrivacyPolicy />
      </PageLayout>
    ),
  },
  {
    path: routes.cookiePolicy,
    element: (
      <PageLayout>
        <CookiePolicy />
      </PageLayout>
    ),
  },
];

export { routes, navMenus, routerData };
